import { persistentAtom } from '@nanostores/persistent';

export const $viewedResources = persistentAtom<string[]>('viewedResources', [], {
  encode: JSON.stringify,
  decode: JSON.parse,
});

export const trackViewedResource = (resourceId: string) => {
  const viewedResources = $viewedResources.get();
  if (!viewedResources.includes(resourceId)) {
    $viewedResources.set([...viewedResources, resourceId]);
  }
};
